import isServerSide from '@bt-react/libs/isServerSide'
import HttpsProxyAgent from 'https-proxy-agent'
import isIn from '../isIn'
import fetch from '../fetch'
import { FetchOptions } from '../fetch'
import logger from '../../libs/logger'

interface FetchJSONResponse<T> {
  data: T | undefined
  status: number
}

/**
 * Returns a proxy if we're server-side and not in prod
 */
export function getProxy(): HttpsProxyAgent.HttpsProxyAgent | undefined {

  if (
    !process.env.PROXY_HOST ||
    !process.env.PROXY_PORT
  ) return
  return HttpsProxyAgent(`http://${process.env.PROXY_HOST}:${process.env.PROXY_PORT}`)

}

async function sanitizeWordPress(response: Response) {

  let textResponse = ''

  try {

    textResponse = await response.text()

  }
  catch (e) {

  }

  if (textResponse) {

    textResponse = textResponse.replace(/"post_content":[\s\S]*?,/gm, '')

    try {

      const response = JSON.parse(textResponse)
      return response

    }
    catch (e) {

    }

  }

  return {}

}

interface FetchJSONOptions extends FetchOptions {
  /** This will be removed once post_content has been removed from the payload */
  sanitizeWP?: boolean
}

const defaultOptions: FetchJSONOptions = {
  includeCredentials: false,
  withProxy: isServerSide,
  sanitizeWP: false,
  headers: {},
  timeout: 9000
}

/**
 * 
 * @param apiLabel A name to add to log entries to identify the API
 * @param url The URL to call
 * @param includeCredentials Should we pass cookies to API [Only applies client-side]
 */
async function fetchJSON<T = any>(
  apiLabel: string, url: string,
  {
    includeCredentials, withProxy, sanitizeWP,
    headers, method, body, timeout
  }: FetchJSONOptions = defaultOptions
): Promise<FetchJSONResponse<T>> {

  const call = await fetch(url, { includeCredentials, withProxy, headers, method, body, timeout })
  const status = (call as Response)?.status;
  let response: any

  if (status === 200 || status === 201) {

    if (sanitizeWP) {

      response = await sanitizeWordPress(call)

    }
    else {

      try {

        response = await call.json()

      }
      catch (e) {

      }

    }

    if (isServerSide) {
      const logdata = {
        URL: call?.url || '',
        STATUS: call?.status || '',
        RESPONSE: response
      }
      logger.debug(JSON.stringify(logdata))
    }

  }
  else {

    const shouldCaptureMessage = !(
      (status === 404 && isIn(apiLabel, 'fetchWebcast')) ||
      (status === 401 && isIn(apiLabel, 'fetchMe', 'fetchUser')) ||
      typeof status === 'undefined' ||
      url.includes('channel/1/')
    )

    if (shouldCaptureMessage) {

    }

    if (

      (status === 400 || status === 404) &&
      isIn(apiLabel, 'createUser', 'callCreateUser', 'fetchWebcast', 'fetchPreAuth', 'updateUserProfile')

    ) {

      try {

        response = await call.json()

        if (isServerSide) {
          const logdata = {
            URL: call?.url || '',
            STATUS: call?.status || '',
            RESPONSE: response
          }
          logger.error(JSON.stringify(logdata))
        }

      }
      catch (e) {

      }

    } else {

      if (isServerSide) {

        const isNotSuppressedError = !(status === 404 && isIn(apiLabel, 'fetchSummit'));

        const res = await call.json()
        const logdata = {
          URL: call?.url || '',
          STATUS: call?.status || '',
          RESPONSE: res
        }

        if (isNotSuppressedError) {
          logger.error(JSON.stringify(logdata))
        } else {
          logger.info(JSON.stringify(logdata))
        }

      }

    }

  }

  return {
    data: response,
    status: status ?? 0
  }

}

export default fetchJSON
